module.exports = "<!-- <div *ngIf=\"!isLoggedIn\">\r\n    <button (click)=\"login()\">Login with my AAD account</button>\r\n</div>\r\n<div *ngIf=\"isLoggedIn\">\r\n    <ngx-loading [show]=\"loading\"></ngx-loading>\r\n</div> -->\r\n\r\n\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Fed/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = main